import { render } from "./Edit.vue?vue&type=template&id=6ba521ca"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ba521ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ba521ca', __exports__)) {
    console.log('reload')
    api.reload('6ba521ca', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=6ba521ca", () => {
    console.log('re-render')
    api.rerender('6ba521ca', render)
  })

}


export default __exports__